import { DSIcon, Breadcrumb } from '../common/atoms';
import React, { Component } from 'react';
import AppointmentsFilter from './AppointmentsFilter'
import { Input, Row, Col, Card, Avatar, Badge, Table, Spin } from 'antd';
import Button from '../common/atoms/DSButton';

const Search = Input.Search;
const { Meta } = Card;

class CustomerAppointments extends Component {

	constructor(props) {
    super(props)
    this.state = {
      customers: [],
      overview: {},
      filters: {},
      current_page: 1,
      loading: false,
      show_filters: false,
      selected_filters: { 
      	selected_locations: [],
        selected_departments: [],
        selected_appointment_status: [],
        selected_appointment_date: ''
      },
      total: 0,
      showCsvLoader: false,
      filtered: false
    }
  }

  onChange = (pageNumber) => {
    this.setState({current_page: pageNumber},function(){
    	if (this.state.filtered){
    		this.fetchFilteredRecords()
    	}
    	else {
      	this.fetchRecords()
    	}
    })
  }

  componentDidMount(){
  	this.fetchOverview()
  	this.fetchFilters()
  	this.fetchRecords()
  }

  searchCustomer(value){
  	this.setState({current_page: 1}, function(){
  		this.fetchRecords(value)
  	})
  }

  exportToCsv = (e) => {  
    let url = window.API_URL + 'corporate/customers/search.csv'
    let request_body = this.generateFilters()
    request_body["download"] = true	
    this.setState({showCsvLoader: true},function(){
      fetch(url, {
      	method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-ekincare-key': sessionStorage.getItem('axiosHeaders')
        },
        body: JSON.stringify(request_body)
      })
      .then(function(response) {
        response.text().then(function(text) {
          var csvText = '<a href="data:text/csv;charset=utf-8,'
                        + escape(text) 
                        + '" download="customers_'+ Date.now() + '.csv">download</a>'         
          window.open().document.write(csvText);
        },this);
      this.setState({showCsvLoader: false})  
      },this)
      .catch((error) => {
        this.setState({showCsvLoader: false})
      });
    })
  }	

  fetchRecords(value) {
    let that = this
    this.setState({loading: true})
    let url = window.API_URL + 'corporate/customers?' +  'page=' + this.state.current_page
    if (value !== null && value !== "" && value !== undefined) {
    	url = url + "&email=" + value
    }
    window.axios.get(url)
    .then(function (response) {
      console.log(response) 
      that.setState({customers: response.data['customers'], total: response.data["meta"]["total"], show_filters: false, loading: false})
    })
    .catch(function (error) {
      that.setState({loading: false})
      console.log(error);
    })
  }

  fetchFilters(){
  	let that = this
    this.setState({loading: true})
    let url = window.API_URL + 'corporate/customers/filters'
    window.axios.get(url)
    .then(function (response) {
      console.log(response) 
      that.setState({filters: response.data, loading: false})
    })
    .catch(function (error) {
      that.setState({loading: false})
      console.log(error);
    })
  }

  fetchOverview(){
  	let that = this
    this.setState({loading: true})
    let url = window.API_URL + 'corporate/customers/overview'
    window.axios.get(url)
    .then(function (response) {
      console.log(response) 
      that.setState({overview: response.data, loading: false})
    })
    .catch(function (error) {
      that.setState({loading: false})
      console.log(error);
    })
  }

  fetchFilteredRecords() {
    let that = this
    let request_body = this.generateFilters()
    if (request_body["filtered"]) {
	    this.setState({loading: true, filtered: true}, function(){
		    let url = window.API_URL + 'corporate/customers/search?' +  'page=' + this.state.current_page
		    window.axios.post(url, request_body)
		    .then(function (response) {
		      that.setState({customers: response.data['customers'], total: response.data["meta"]["total"], show_filters: false, loading: false})
		    })
		    .catch(function (error) {
		      that.setState({loading: false})
		      console.log(error);
		    })
	    })
	  }  
	  else {
	  	this.setState({filtered: false}, function(){
	  		this.fetchRecords()
	  	})
	  }  
  }

  generateFilters(){
    let query = {}
    let filtered = false
    if (this.state.selected_filters.selected_locations.length > 0){
      query["locations"] = this.state.selected_filters.selected_locations
      filtered = true
    }
    if (this.state.selected_filters.selected_departments.length > 0){
      query["departments"] = this.state.selected_filters.selected_departments
    	filtered = true
    }
    if (this.state.selected_filters.selected_appointment_status.length > 0){
      query["appointment_status"] = this.state.selected_filters.selected_appointment_status
    	filtered = true
    }
    if (this.state.selected_filters.selected_appointment_date){
      query["appointment_date"] = this.state.selected_filters.selected_appointment_date
      filtered = true
    }
    query["filtered"] = filtered   
    return query
  }
 
  voucherDownload = (record_id,e) => {
    fetch((window.API_URL  + 'corporate/customers/' + String(record_id) + '/download_voucher'),{
      headers: {
        'x-ekincare-key': sessionStorage.getItem('axiosHeaders')
      },       
    })
    .then(function(response) {
      response.text().then(function(text) {
        var htmlText = '<iframe width=100% height=700px'
                 + ' type="application/pdf"'
                 + ' src="data:application/pdf,'
                 + escape(text)
                 + '"></iframe>';
        window.open().document.write(htmlText);
      });
    })
    .catch((error) => {
      console.error(error);
    });
  }

  columns(){
  	let columns = []
  	columns.push({
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      })
    columns.push({
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    })
    columns.push({
      title: 'Employee Id',
      dataIndex: 'employee_id',
      key: 'employee_id'
    })
    columns.push({
      title: 'Location',
      dataIndex: 'sponsor_location',
      key: 'location'
    })
    columns.push({
      title: 'Department',
      dataIndex: 'sponsor_department',
      key: 'department'
    })
    columns.push({
      title: 'Appointment Status',
      dataIndex: 'appointment_status',
      key: 'appointment_status',
      render: (text, record) => {
        return(
          <p>{record.appointment_data["appointment_status"]}</p>
        )
      }
    })
    columns.push({
      title: 'Appointment Date',
      render: (text, record) => {
        if (record.appointment_data["appointment_date"]){
          return(
            <p>{record.appointment_data["appointment_date"]}</p>
          )
        }
        else{
          return(<p>-</p>)
        }
      }
    })
    columns.push({
      title: 'Voucher',
      render: (text, record) => {
        if (record.appointment_data["appointment_status"] === "confirmed"){
          return(
            <span>
              <Button type='primary' style={{marginLeft: 5}} onClick={this.voucherDownload.bind(this, record.appointment_data["appointment_id"])}><DSIcon name='download' className='inline-block text-white' size={16} /></Button>
            </span>
          )
        }
        else{
          return(<p>-</p>)
        }
      }
    })
    columns.push({
    	title: this.showFilters()
    })
    return columns
  }

  showFilters(){
  	return(
  		<Badge count={this.renderFiltersCount()}>
          <Button onClick={this.enableFilters}><DSIcon name='filter' className='inline-block text-gray-600' size={16} /></Button>
  		</Badge>
  	)
  }

  renderFiltersCount(){
  	let count = 0
  	count = this.state.selected_filters.selected_locations.length > 0 ? count + 1 : count
  	count = this.state.selected_filters.selected_departments.length > 0 ? count + 1 : count
  	count = this.state.selected_filters.selected_appointment_status.length > 0 ? count + 1 : count
  	return count
  }

  enableFilters = () => {
  	this.setState({show_filters: true})
  }

  cancelModal(e){
  	this.setState({show_filters: false})
  }

  updateFilters(obj){
  	this.setState({selected_filters: obj, current_page: 1},function(){
  		this.fetchFilteredRecords()
  	})  
  }

  renderFilters(){
  	if (this.state.show_filters) {
  		return(<AppointmentsFilter visible={this.state.show_filters} filters={this.state.filters} selected_filters={this.state.selected_filters} updateFilters={this.updateFilters.bind(this)} closeModal={this.cancelModal.bind(this)} />)
  	}
  	else {
  		return(<div/>)
  	}
  }

  renderCsvLoader(){
    if(this.state.showCsvLoader === true){
      return(<p>Preparing CSV .....<DSIcon name='spinner' className='inline-block text-blue-600' size={16} spin /></p>)
    }
    else{
      return("")
    }
  }

  render(){
  	return(
  		<div>
  			<Breadcrumb list={[{ text: 'Customer appointments', link: '#' }]} classes='mb-1' />
  		<Row gutter={16} style={{marginBottom: 20, overflowX: 'auto', whiteSpace: 'nowrap'}}>
					<Col sm = {24} md={6}>
						<Card>
							<Meta
	      				avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1536574281/hr_dashboard_overview/health_checkup.svg" />}
	      				title={this.state.overview.ongoing_health_checks_count}
	      				description="Ongoing Healthchecks"
	    				/>
						</Card>
					</Col>					
					<Col sm = {24} md={6}>
						<Card>
							<Meta
	      				avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1536574281/hr_dashboard_overview/health_checkup.svg" />}
	      				title={this.state.overview.completed_health_checks_count}
	      				description="Completed Healthchecks"
	    				/>
						</Card>
					</Col>
					<Col sm = {24} md={6}>
						<Card>
							<Meta
	      				avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1536573111/hr_dashboard_overview/digitized_report.svg" />}
	      				title={this.state.overview.report_digitized_count}
	      				description="Report Digitized"
	    				/>
						</Card>
					</Col>
					<Col sm = {24} md={6}>
						<Card>
							<Meta
	      				avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1536574281/hr_dashboard_overview/health_checkup.svg" />}
	      				title={this.state.overview.not_booked_count}
	      				description="Did not book healthchecks"
	    				/>
						</Card>
					</Col>
				</Row>
			<Row>
				<Col span={16}>	
					<Row type='flex' justify='start' style={{marginBottom: 20}}>
						<Search
		          size='large'
		          placeholder="Search using email"
		          style={{ width: 300 }}
		          onSearch={value => this.searchCustomer(value)}
		        />
		      </Row>
		    </Col>  
		    <Col span={8}>  
		      <Row type = 'flex' justify='end'> 
	          <Button type='primary' size='large' onClick={this.exportToCsv} ghost> <DSIcon name='download' className='mr-2 inline-block text-blue-600' size={16} /> Export to CSV </Button>
	        </Row>
	        <Row type='flex' justify='end'> 	
	          	{this.renderCsvLoader()}		
					</Row>
				</Col>	
			</Row>		
			<Row type='flex' justify='end'>
				<h4>Total: {this.state.total}</h4>
			</Row>
			<Row gutter={16} style={{margin: 0, background:"#ffffff"}}>	
	  		<Spin spinning={this.state.loading}>
	        <Table  rowKey="id" dataSource={this.state.customers} style={{overflowX: 'auto', whiteSpace: 'nowrap'}} pagination={{pageSize: 15, total: this.state.total, onChange: this.onChange}} columns={this.columns()} />
	      </Spin>
      </Row>
     	{this.renderFilters()} 
     </div>            
  	)
  }

}


export default CustomerAppointments;
